import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';
import { useMemo } from 'react';
import { getTime } from '../scheduleHelper';
import ScheduleRow from './ScheduleRow';

const isBeforeBreak = (time) => {
  return parseInt(time.slice(0, 2), 10) < 15;
};

const sliceSchedule = (schedule, fromIndex, toIndex) => {
  const keys = Object.keys(schedule);
  const endIndex = toIndex ?? keys.length;
  return keys.slice(fromIndex, endIndex).reduce((slicedSchedule, liveAt) => {
    return {
      ...slicedSchedule,
      [liveAt]: schedule[liveAt]
    };
  }, {});
};

const createSchedule = (schedule, dates) =>
  Object.keys(schedule).map((liveAt) => {
    return (
      <ScheduleRow
        key={liveAt}
        data={schedule[liveAt]}
        liveAt={liveAt}
        dates={dates}
      />
    );
  });

const Schedule = ({ schedule, dates }) => {
  const formattedSchedule = useMemo(() => {
    const flatSchedule = schedule.reduce((fullSchedule, daySchedule) => {
      const data = daySchedule.data.map((scheduledClass) => ({
        ...scheduledClass,
        date: daySchedule.date,
        liveAt: `${getTime(scheduledClass.live_at, 'hrs')} : ${getTime(
          scheduledClass.live_at
        )}`
      }));
      return fullSchedule.concat(data);
    }, []);
    const timeGroupedData = groupBy(flatSchedule || [], 'liveAt');
    const timeKeys = Object.keys(timeGroupedData);
    timeKeys.sort();
    const timeGroupedSortedData = {};
    timeKeys.forEach((liveAt) => {
      const dateGroupedData = groupBy(timeGroupedData[liveAt], 'date');
      timeGroupedSortedData[liveAt] = dates.reduce(
        (data, date) => ({ ...data, [date]: dateGroupedData[date] }),
        {}
      );
    });
    return timeGroupedSortedData;
  }, [dates, schedule]);

  const scheduleContent = useMemo(() => {
    const breakIndex = Object.keys(formattedSchedule).findIndex(
      (liveAt) => !isBeforeBreak(liveAt)
    );
    let scheduleBeforeBreak = formattedSchedule;
    let scheduelAfterBreak = {};
    if (breakIndex > -1) {
      scheduleBeforeBreak = sliceSchedule(formattedSchedule, 0, breakIndex);
      scheduelAfterBreak = sliceSchedule(formattedSchedule, breakIndex);
    }
    return (
      <>
        {createSchedule(scheduleBeforeBreak, dates)}
        {createSchedule(scheduelAfterBreak, dates)}
      </>
    );
  }, [dates, formattedSchedule]);

  return scheduleContent;
};

Schedule.propTypes = {
  schedule: PropTypes.arrayOf(PropTypes.object).isRequired,
  dates: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Schedule;
